<template>
  <div class="border-b border-stroke">
    <nav class="-mb-px flex gap-1 overflow-x-auto" aria-label="Abas">
      <button
        v-for="tab in visibleTabs"
        :key="tab.id"
        type="button"
        :class="[
          'whitespace-nowrap border-b-2 px-4 py-3 text-sm font-medium transition',
          activeTab === tab.id
            ? 'border-blue text-blue'
            : 'border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700',
        ]"
        @click="activeTab = tab.id">
        {{ tab.label }}
      </button>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

export type ProfileTabId = 'profile' | 'company'

const props = defineProps<{
  modelValue: ProfileTabId
}>()

const emit = defineEmits<{
  'update:modelValue': [value: ProfileTabId]
}>()

const activeTab = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
})

const allTabs: { id: ProfileTabId; label: string }[] = [
  { id: 'profile', label: 'Meu perfil' },
  { id: 'company', label: 'Empresa' },
]

const visibleTabs = computed(() => allTabs)
</script>
